import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import AnimatedSection, { AnimatedGrid } from '../AnimatedSection';
import CommonTitle from '../CommonTitle';

const Automotive2: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Automotive2');
    return (
        <div className={styles.Automotive2 + ' GtmModuleData-section'} data-section-id="d3m-automotive2">
            <EcoImg
                className="bg"
                pc="https://websiteoss.ecoflow.com/figma-uploads/1758603219171-8jf7kz-compressed-Frame%202094654421.jpg"
                pad="https://websiteoss.ecoflow.com/figma-uploads/1758603219171-8jf7kz-compressed-Frame%202094654421.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1758603400398-lfzuyb-compressed-Frame%202094654424.jpg"
                isOpenLazy={true}
            />
            <div className="d3m-layout ">
                <div className="text-wrapper">
                    <CommonTitle
                        title={t('title')}
                        desc={t.rich('desc', {
                            sup: (text: string) => <sup>{text}</sup>,
                        })}
                    />

                    <AnimatedGrid variant="rotateIn" options={{ delay: 400, stagger: 0.15, threshold: 0.2 }} className="list-wrapper">
                        <div className="list-item">
                            <div className="list-item-title">{t('list1_title')}</div>
                            {t('list1_desc') && (
                                <div className="list-item-desc">
                                    {t.rich('list1_desc', {
                                        sup: (text: string) => <sup>{text}</sup>,
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="list-item">
                            <div className="list-item-title">{t('list2_title')}</div>
                            <div className="list-item-desc">
                                {t('list2_desc') &&
                                    t.rich('list2_desc', {
                                        sup: (text: string) => <sup>{text}</sup>,
                                    })}
                            </div>
                        </div>
                    </AnimatedGrid>
                </div>
            </div>
        </div>
    );
};

export default Automotive2;
